import { gql } from '@apollo/client';

import baseFields from '../base';

const NOTIFICATIONS_FRAGMENT = gql`
  fragment NotificationsFragment on Notification {
    ${baseFields}
    title
    description
    sender
    link
    receiver
    type
    scope
    data
  }
`;

export default NOTIFICATIONS_FRAGMENT;
